import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { AdminLayout } from '@/components/AdminLayout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Program from '@/pages/Program';
import Houses from '@/pages/Houses';
import Curriculum from '@/pages/Curriculum';
import Apply from '@/pages/Apply';
import Partners from '@/pages/Partners';
import Donate from '@/pages/Donate';
import DonateSuccess from '@/pages/DonateSuccess';
import News from '@/pages/News';
import NewsDetail from '@/pages/NewsDetail';
import Contact from '@/pages/Contact';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import ApplicationDetail from '@/pages/admin/ApplicationDetail';
import AdminPartners from '@/pages/admin/AdminPartners';
import AdminContacts from '@/pages/admin/AdminContacts';
import AdminBlog from '@/pages/admin/AdminBlog';
import AdminDonations from '@/pages/admin/AdminDonations';
import BlogEditor from '@/pages/admin/BlogEditor';
import { Toaster } from 'sonner';
import '@/App.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/program" element={<Layout><Program /></Layout>} />
          <Route path="/houses" element={<Layout><Houses /></Layout>} />
          <Route path="/curriculum" element={<Layout><Curriculum /></Layout>} />
          <Route path="/apply" element={<Layout><Apply /></Layout>} />
          <Route path="/partners" element={<Layout><Partners /></Layout>} />
          <Route path="/donate" element={<Layout><Donate /></Layout>} />
          <Route path="/donate/success" element={<Layout><DonateSuccess /></Layout>} />
          <Route path="/news" element={<Layout><News /></Layout>} />
          <Route path="/news/:slug" element={<Layout><NewsDetail /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="applications/:id" element={<ApplicationDetail />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="donations" element={<AdminDonations />} />
            <Route path="blog/new" element={<BlogEditor />} />
            <Route path="blog/edit/:id" element={<BlogEditor />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </>
  );
}

export default App;
